import { atom } from 'jotai';

export const sidebarCollapsedAtom = atom(false);

export const toggleSidebarAtom = atom(null, (get, set) => {
	set(sidebarCollapsedAtom, !get(sidebarCollapsedAtom));
});
